module.exports = __webpack_public_path__ + "img/cn_pocket-4.0c8c3fc.jpg";